var scope_0 = require('/Users/viktorohlin/Dropbox (personliga)/PRODUKTION/2023/SKGSDN/skuggsidan-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0 )
    